import { Client } from "urql";
import {
  AddUserToCrewMutation,
  AddUserToCrewMutationVariables,
} from "../gql/graphql";
import { graphql } from "../gql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export class CrewJoiner {
  private readonly graphQlClient: Client;

  private readonly addUserToCrewMutation: TypedDocumentNode<
    AddUserToCrewMutation,
    AddUserToCrewMutationVariables
  > = graphql(`
    mutation addUserToCrew($joiningIdentifier: String!) {
      addUserToCrew(joiningIdentifier: $joiningIdentifier) {
        title
      }
    }
  `);

  constructor(graphQlClient: Client) {
    this.graphQlClient = graphQlClient;

    this.joinCrew = this.joinCrew.bind(this);
  }

  joinCrew(joiningIdentifier: string): Promise<string> {
    return this.graphQlClient
      .mutation(this.addUserToCrewMutation, {
        joiningIdentifier: joiningIdentifier,
      })
      .toPromise()
      .then((result) => {
        if (result.error === undefined && result.data !== undefined) {
          const title = result.data.addUserToCrew.title;
          return Promise.resolve(title);
        } else {
          return Promise.reject(result);
        }
      });
  }
}
